export const backgroundColors = {
  default: {
    light: 'bg-white',
    dark: 'bg-[#2C2E2D]'
  }
} as const;

export const colors = {
  primary: {
    DEFAULT: '#CCF751',
    hover: 'rgb(204 255 0 / 0.1)',
    active: 'rgb(204 255 0 / 0.2)',
  },
  secondary: {
    DEFAULT: '#10B981',
    hover: 'rgb(16 185 129 / 0.1)',
    active: 'rgb(16 185 129 / 0.2)',
  },
  accent: {
    DEFAULT: '#F59E0B',
    hover: 'rgb(245 158 11 / 0.1)',
    active: 'rgb(245 158 11 / 0.2)',
  },
  destructive: {
    DEFAULT: '#FB7185',
    hover: 'rgb(251 113 133 / 0.1)',
    active: 'rgb(251 113 133 / 0.2)',
  },
  text: {
    light: {
      primary: '#2C2E2D',
      secondary: '#4A4B4A',
      muted: '#818881'
    },
    dark: {
      primary: '#D9D9D9',
      secondary: '#818881',
      muted: '#4A4B4A'
    }
  },
  status: {
    interested: {
      bg: 'rgb(204 255 0 / 0.2)',
      text: '#CCFF00',
      icon: '#CCFF00',
    },
    applied: {
      bg: 'rgb(16 185 129 / 0.2)',
      text: '#10B981',
      icon: '#10B981',
    },
    interview: {
      bg: 'rgb(245 158 11 / 0.2)',
      text: '#F59E0B',
      icon: '#F59E0B',
    },
    offer: {
      bg: 'rgb(204 255 0 / 0.2)',
      text: '#CCFF00',
      icon: '#CCFF00',
    },
    rejected: {
      bg: 'rgb(251 113 133 / 0.2)',
      text: '#FB7185',
      icon: '#FB7185',
    },
    archived: {
      bg: 'rgb(156 163 175 / 0.2)',
      text: '#9CA3AF',
      icon: '#9CA3AF',
    },
  },
  border: {
    light: '#E5E7E5',
    dark: '#818881'
  }
} as const;

export const commonStyles = {
  button: {
    primary: "bg-[#CCF751] text-[#2C2E2D] hover:bg-[#CCF751]/90",
    secondary: "bg-[#818881] text-[#D9D9D9] hover:bg-[#818881]/90",
    ghost: "hover:bg-[#818881]/20",
    ghostPrimary: "text-[#CCF751] hover:text-[#CCF751]/90 hover:bg-[#CCF751]/10",
    ghostDestructive: "text-rose-400 hover:text-rose-300 hover:bg-rose-400/10",
    filter: "border bg-[#818881]/30 hover:bg-[#CCF751]/90 hover:text-[#2C2E2D] text-[#D9D9D9] border-[#818881]",
    filterActive: "bg-[#CCF751] text-[#2C2E2D] border-[#CCF751] hover:bg-[#CCF751]/90",
  },
  dialog: "bg-[#2C2E2D] border-[#818881]",
  dialogTitle: "text-[#D9D9D9] font-semibold text-xl",
  dialogDescription: "text-[#818881]",
  dialogCancel: "bg-[#818881]/20 text-[#D9D9D9] hover:bg-[#CCF751]/90 hover:text-[#2C2E2D] border-[#818881]",
  dialogAction: "bg-[#CCF751] text-[#2C2E2D] hover:bg-[#CCF751]/90",
  input: "focus-visible:ring-[#CCF751] focus-visible:ring-offset-0",
  card: "bg-[#2C2E2D] border-[#818881] text-[#D9D9D9] hover:border-[#CCF751] transition-colors",
  dropdown: "bg-[#2C2E2D] border-[#818881]",
  dropdownItem: "text-[#D9D9D9] hover:bg-[#818881]/20 focus:bg-[#818881]/20",
  dropdownSeparator: "bg-[#818881]",
  jobStatus: {
    interested: "bg-[#CCF751]/10 text-[#CCF751] border-[#CCF751]/20",
    applied: "bg-emerald-400/10 text-emerald-400 border-emerald-400/20",
    interview: "bg-amber-400/10 text-amber-400 border-amber-400/20",
    offer: "bg-[#CCF751]/10 text-[#CCF751] border-[#CCF751]/20",
    rejected: "bg-rose-400/10 text-rose-400 border-rose-400/20",
  }
} as const; 